import React from 'react';

import { ColumnsType } from 'antd/es/table';
import { Dayjs } from 'dayjs';

import { PagintaionParams } from 'shared/CustomPagination/CustomPagination';
import TableSchedules from 'shared/TableComponents/TableSchedules';
import TableTimePicker from 'shared/TableComponents/TableTimePicker';

import { CoachesBooking, SelectedBookingCoach } from 'features/coachesBooking';
import { WorkTime } from 'features/config';
import { AccountData } from 'features/user';

import GraphColumns from './components/GraphColumns';


interface Props {
  onTimeChange: (arg: Dayjs) => void;
  handleBooking: (arg: SelectedBookingCoach) => void;
  items: CoachesBooking;
  bookingTime: null | Dayjs;
  params: PagintaionParams;
  handleCheckDetail: (id: number) => void;
  workTime: WorkTime;
  userInfo: AccountData;
}
export interface TableData extends CoachBooking {
  key: number;
}

type CoachBooking = CoachesBooking[number];

function BookingTableColumns({
  onTimeChange,
  handleBooking,
  handleCheckDetail,
  items,
  bookingTime,
  params,
  workTime,
  userInfo
}: Props): ColumnsType<TableData> {
  return (
    [
      TableTimePicker({ onTimeChange }), {
        dataIndex: 'columns',
        title: <TableSchedules currentTime={bookingTime} onTimeChange={onTimeChange} />,
        children: [
          ...GraphColumns({
            handleBooking,
            handleCheckDetail,
            items,
            params,
            workTime,
            userInfo
          }),
          {
            onCell: () => ({
              style: {
                border: 'none',
                backgroundColor: 'white'
              }
            })
          }
        ]
      }]
  );
}

export default BookingTableColumns;
